export enum ContractStatusEnum {
    Pending = 1,
    Valid = 2,
    Cancelled = 3,
    Expired = 4,
    Rejected = 5,
    Closed = 6,
    Updated = 8,
}

export interface ContractStatusEnumDisplayNames {
    [key: number]: string;
}

export const ContractStatusEnumDisplayNames: ContractStatusEnumDisplayNames = {
    [ContractStatusEnum.Pending]: 'في انتظار الاعتماد',
    [ContractStatusEnum.Valid]: 'معتمد',
    [ContractStatusEnum.Cancelled]: 'ملغى',
    [ContractStatusEnum.Expired]: 'منتهي',
    [ContractStatusEnum.Rejected]: 'مرفوض',
    [ContractStatusEnum.Closed]: 'مغلق',
    [ContractStatusEnum.Updated]: 'محدث',
};
